import { isDefined } from "../utils";

const defaultOptions = {
  distance: 10,
};

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    if (!data || data.length === 0) return [];

    const { distance } = options;
    const len = data.length;
    const results = new Array(len);

    // State variables
    let ll = null; // Lowest low
    let hh = null; // Highest high
    let direction = 0; // -1 = looking for low, 1 = looking for high, 0 = initial
    let bar = 0; // Current pivot point index
    let previousBar = 0; // Previous pivot point index
    let zig = null; // Zig threshold (high threshold for downward movement)
    let zag = null; // Zag threshold (low threshold for upward movement)

    // Helper function to interpolate values between pivot points
    function fillBetweenPoints(start, end) {
      if (start >= end || start < 0 || end >= len) return;

      const startValue = results[start];
      const endValue = results[end];

      if (!isDefined(startValue) || !isDefined(endValue)) return;

      for (let i = start + 1; i < end; i++) {
        const progress = (i - start) / (end - start);
        results[i] = startValue + (endValue - startValue) * progress;
      }
    }

    // Main loop
    for (let i = 0; i < len; i++) {
      const d = data[i];

      if (
        !d ||
        !isDefined(d.high) ||
        !isDefined(d.low) ||
        !isDefined(d.close)
      ) {
        results[i] = undefined;
        continue;
      }

      const thisHigh = d.high;
      const thisLow = d.low;

      // Update highest high
      if (hh === null || hh < thisHigh) {
        hh = thisHigh;
        if (direction < 0) ll = thisLow;
        zig = (1 - distance / 100) * hh;

        if (direction > -1) {
          // Check if we've moved down enough from the high to create a new pivot
          if (zag !== null && hh > zag) {
            results[bar] = data[bar].low;
            fillBetweenPoints(previousBar, bar);
            direction = -1;
            ll = thisLow;
            previousBar = bar;
            bar = i;
            continue;
          }
        } else {
          bar = i;
        }
      }

      // Update lowest low
      if (ll === null || ll > thisLow) {
        ll = thisLow;
        if (direction > 0) hh = thisHigh;
        zag = (1 + distance / 100) * ll;

        if (direction < 1) {
          // Check if we've moved up enough from the low to create a new pivot
          if (zig !== null && ll < zig) {
            results[bar] = data[bar].high;
            fillBetweenPoints(previousBar, bar);
            direction = 1;
            hh = thisHigh;
            previousBar = bar;
            bar = i;
            continue;
          }
        } else {
          bar = i;
        }
      }
    }

    // Set the last pivot point
    results[bar] = direction === 1 ? data[bar].low : data[bar].high;
    fillBetweenPoints(previousBar, bar);

    // Extend to the last bar
    if (bar < len - 1) {
      results[len - 1] =
        direction === 1 ? data[len - 1].high : data[len - 1].low;
      fillBetweenPoints(bar, len - 1);
    }

    return results;
  }

  calculator.undefinedLength = function () {
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
